import {
  buildListParams,
  getListData,
  getTotalRecords,
  handleListDeleteIconMouseEnter,
  handleListIconMouseEnter,
  handleListIconMouseLeave,
  listStyles,
  loadStoredJson,
  removeStoredKeys,
  saveStoredValue
} from 'lib/listUtils';
import {
  Button,
  Card,
  CardContent,
  Input,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip
} from '@material-ui/core';
import {
  BackspaceOutlined,
  DeleteForeverOutlined,
  EditTwoTone,
  Search,
  VisibilityOutlined
} from '@material-ui/icons';
import api from 'services/api';
import { ANAO, ASIM } from 'consts';
import { Link } from 'react-router-dom';
import React, { Component } from 'react';
import { safeSetState } from 'lib/reactUtils';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { AlertInformation, DeleteConfirmationModal } from 'components';

class UsuarioList extends Component {
  state = {
    searchFilter: loadStoredJson('usuarioSearchFilter', {
      usuario: '',
      inativo: ANAO
    }),
    usuarios: [],
    open: false,
    openAlert: false,
    messageAlert: '',
    selectedId: null,
    selectedDesc: '',
    totalItems: 0,
    page: Number(sessionStorage.getItem('usuarioPage')) || 0,
    rowsPerPage: Number(sessionStorage.getItem('usuarioRowsPerPage')) || 10
  };

  estilo = listStyles;

  _isMounted = false;

  handleIconMouseEnter = handleListIconMouseEnter;
  handleIconMouseLeave = handleListIconMouseLeave;
  handleDeleteIconMouseEnter = handleListDeleteIconMouseEnter;
  safeSetState = safeSetState;

  /* Carregamento os dados iniciais da tela */
  async componentDidMount() {
    this._isMounted = true;
    await this.loadUsuarios();
  };

  /* Paginação */
  componentDidUpdate(prevProps, prevState) {
    const { searchFilter, page, rowsPerPage } = this.state;

    // persiste os filtros e a paginação no sessionStorage
    if (prevState.searchFilter !== searchFilter) {
      saveStoredValue('usuarioSearchFilter', searchFilter);
    }

    if (prevState.page !== page) {
      saveStoredValue('usuarioPage', page);
    }

    if (prevState.rowsPerPage !== rowsPerPage) {
      saveStoredValue('usuarioRowsPerPage', rowsPerPage);
    }
  };

  /* Limpa os filtros e a paginação ao sair da tela */
  componentWillUnmount() {
    this._isMounted = false;

    removeStoredKeys([
      'usuarioSearchFilter',
      'usuarioPage',
      'usuarioRowsPerPage'
    ]);
  };

  /* Carrega os usuários */
  loadUsuarios = async () => {
    const { page, rowsPerPage, searchFilter } = this.state;
    const { usuario, inativo } = searchFilter;

    const params = buildListParams({
      page,
      rowsPerPage,
      filters: [
        {
          field: 'USUARIO',
          value: usuario,
          operator: '_like_'
        },
        {
          field: 'INATIVO',
          value: inativo
        }
      ]
    });

    try {
      const response = await api.get('/usuario' + params);

      this.safeSetState({
        usuarios: getListData(response),
        totalItems: getTotalRecords(response)
      });
    } catch (error) {
      console.error('Erro ao carregar usuários:', error);

      this.safeSetState({
        usuarios: [],
        totalItems: 0
      });
    }
  };

  /* Muda a página */
  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage }, this.loadUsuarios);
  };

  /* Muda a quantidade de retornos por página */
  handleChangeRowsPerPage = (event) => {
    this.setState({
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0
    }, this.loadUsuarios);
  };

  /* Deleta o usuário */
  handleDelete = async (id) => {
    try {
      const response = await api.delete(`/usuario/${id}`);

      // verifica se a exclusão foi bem-sucedida
      if (response.status === 200) {
        this.handleClose();
        this.loadUsuarios();
      }
    } catch (error) {
      this.handleClose();

      this.handleOpenAlert(
        error.response?.data?.error ||
        error.response?.data?.message ||
        'Erro ao excluir usuário!'
      );
    }
  };

  /* Confirma a exclusão */
  handleConfirmDelete = () => {
    const { selectedId } = this.state;

    this.handleDelete(selectedId);
  };

  /* Abre a janela de confirmação para a exclusão */
  handleOpen = (id, descricao) => {
    this.setState({
      open: true,
      selectedId: id,
      selectedDesc: descricao
    });
  };

  /* Abre a janela de alerta com mensagem */
  handleOpenAlert = (message) => {
    this.setState({
      openAlert: true,
      messageAlert: message
    });
  };

  /* Fecha a janela de confirmação da exclusão */
  handleClose = () => {
    this.setState({
      open: false,
      selectedId: null,
      selectedDesc: ''
    });
  };

  /* Fecha a janela de mensagem alerta */
  handleCloseAlert = () => {
    this.setState({ openAlert: false });
  };

  /* Pesquisa os filtros na tela */
  onChangeSearch = (event) => {
    const { name, value } = event.target;

    const searchFilter = {
      ...this.state.searchFilter,
      [name]: (typeof value === 'string') ? value.toUpperCase() : value
    };

    this.setState({
      searchFilter,
      page: 0
    });
  };

  /* Limpa os filtros da tela */
  limpaFiltros = () => {
    const searchFilter = {
      usuario: '',
      inativo: ANAO
    };

    this.setState({
      searchFilter,
      page: 0
    }, this.loadUsuarios);
  };

  render() {
    const {
      messageAlert,
      open,
      openAlert,
      page,
      rowsPerPage,
      searchFilter,
      selectedDesc,
      selectedId,
      totalItems,
      usuarios
    } = this.state;

    const basePath = this.props.match?.url || '';

    const {
      actionIcon,
      addButton,
      filterPaper,
      iconGroup,
      redText
    } = this.estilo;

    return (
      <div style={this.estilo}>
        <Paper
          style={{
            ...filterPaper,
            width: '100%'
          }}
        >
          <Input
            autoFocus
            id="usuario"
            name="usuario"
            onChange={this.onChangeSearch}
            placeholder="Usuário"
            value={searchFilter.usuario}
            style={{
              flex: '0 1 200px',
              minWidth: 200
            }}
          />

          <Select
            id="inativo"
            name="inativo"
            onChange={this.onChangeSearch}
            value={searchFilter.inativo || ''}
            style={{
              flex: '0 1 100px',
              minWidth: 100,
              textAlign: 'center'
            }}
          >
            <MenuItem
              value={ANAO}
              style={{ justifyContent: 'center' }}
            >
              Ativos
            </MenuItem>

            <MenuItem
              value={ASIM}
              style={{ justifyContent: 'center' }}
            >
              Inativos
            </MenuItem>

            <MenuItem
              value={'T'}
              style={{ justifyContent: 'center' }}
            >
              Todos
            </MenuItem>
          </Select>

          <span style={iconGroup}>
            <Tooltip title="Procurar">
              <Search
                onClick={this.loadUsuarios}
                onMouseEnter={this.handleIconMouseEnter}
                onMouseLeave={this.handleIconMouseLeave}
                style={actionIcon}
              />
            </Tooltip>

            <Tooltip title="Limpar">
              <BackspaceOutlined
                onClick={this.limpaFiltros}
                onMouseEnter={this.handleIconMouseEnter}
                onMouseLeave={this.handleIconMouseLeave}
                style={actionIcon}
              />
            </Tooltip>
          </span>

          <div style={{ flex: 1 }} />

          <Button
            component={Link}
            to={`${basePath}/novo`}
            variant="contained"
            color="primary"
            style={addButton}
          >
            Novo
          </Button>
        </Paper>

        <br />

        <Card>
          <CardContent>
            <PerfectScrollbar>
              <div>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">Código</TableCell>

                      <TableCell align="center">Usuário</TableCell>

                      <TableCell align="center">Ações</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {usuarios.length === 0 && (
                      <TableRow>
                        <TableCell
                          align="center"
                          colSpan={3}
                        >
                          Nenhum usuário encontrado
                        </TableCell>
                      </TableRow>
                    )}

                    {usuarios.map(usuario => (
                      <TableRow
                        hover
                        key={usuario.codusuario}
                      >
                        <TableCell
                          align="center"
                          style={(usuario.inativo === ASIM) ? redText : {}}
                        >
                          {usuario.codusuario}
                        </TableCell>

                        <TableCell
                          align="center"
                          style={(usuario.inativo === ASIM) ? redText : {}}
                        >
                          {usuario.usuario}
                        </TableCell>

                        <TableCell align="center">
                          <span style={iconGroup}>
                            <Tooltip title="Editar">
                              <Link to={`${basePath}/${usuario.codusuario}`}>
                                <EditTwoTone
                                  onMouseEnter={this.handleIconMouseEnter}
                                  onMouseLeave={this.handleIconMouseLeave}
                                  style={actionIcon}
                                />
                              </Link>
                            </Tooltip>

                            <Tooltip title="Visualizar">
                              <Link to={`${basePath}/${usuario.codusuario}/view`}>
                                <VisibilityOutlined
                                  onMouseEnter={this.handleIconMouseEnter}
                                  onMouseLeave={this.handleIconMouseLeave}
                                  style={actionIcon}
                                />
                              </Link>
                            </Tooltip>

                            <Tooltip title="Excluir">
                              <DeleteForeverOutlined
                                onMouseEnter={this.handleDeleteIconMouseEnter}
                                onMouseLeave={this.handleIconMouseLeave}
                                onClick={() => this.handleOpen(
                                  usuario.codusuario,
                                  usuario.usuario
                                )}
                                style={actionIcon}
                              />
                            </Tooltip>
                          </span>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
            </PerfectScrollbar>

            <TablePagination
              component="div"
              count={totalItems}
              page={page}
              onPageChange={this.handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={this.handleChangeRowsPerPage}
              rowsPerPageOptions={[10, 50, 100, 200]}
              labelRowsPerPage="Registros por página"
            />
          </CardContent>
        </Card>

        <DeleteConfirmationModal
          open={open}
          itemId={selectedId}
          message={`Confirma exclusão do usuário ${selectedDesc || ''} [${selectedId}]?`}
          handleClose={this.handleClose}
          handleDelete={this.handleConfirmDelete}
        />

        <AlertInformation
          open={openAlert}
          message={messageAlert}
          handleClose={this.handleCloseAlert}
        />
      </div>
    );
  }
};

export default UsuarioList;